<template>
  <!-- Centre d'aide / FAQ -->
  <section class="py-16 px-64 bg-gray-50">
    <div class="mx-auto">
      <h2 class="text-2xl font-bold mb-8 text-center">Questions fréquentes</h2>
      <div class="space-y-8">
        <div v-for="(item, idx) in faq" :key="idx" class="bg-white rounded-lg shadow">
          <button
            class="w-full text-left !m-0 !p-4 !py-6 font-semibold flex justify-between items-center focus:outline-none"
            @click="toggleFaq(idx)"
          >
            <span>{{ item.question }}</span>
            <span>
              <svg v-if="openedFaq === idx" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7" /></svg>
              <svg v-else xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" /></svg>
            </span>
          </button>
          <div v-if="openedFaq === idx" class="text-left text-gray-600 p-4" v-html="item.answer">
            
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'FAQSection',
  props: ['faq'],
  data() {
    return {
      openedFaq: null,
    }
  },
  methods: {
    toggleFaq(idx) {
      this.openedFaq = this.openedFaq === idx ? null : idx;
    },
  }
}
</script>